/* REQ-010 S9 · desktop gallery arrows + counter on the theme's Flickity product slideshow. */
(function () {
  'use strict';
  var MQ = window.matchMedia('(min-width: 769px)');
  function arrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pm-gdesk__btn pm-gdesk__btn--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'התמונה הקודמת' : 'התמונה הבאה');
    b.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M9 6l6 6-6 6' : 'M15 6l-6 6 6 6') + '"/></svg>';
    return b;
  }
  function setup(slideshow) {
    if (slideshow.dataset.pmGdesk) return;
    var F = window.Flickity && window.Flickity.data ? window.Flickity.data(slideshow) : null;
    if (!F || !F.slides || F.slides.length < 2) return;
    slideshow.dataset.pmGdesk = '1';
    var wrap = slideshow.closest('.product__main-photos') || slideshow.parentElement;
    var layer = document.createElement('div'); layer.className = 'pm-gdesk';
    var prev = arrow('prev'), next = arrow('next');
    var count = document.createElement('span'); count.className = 'pm-gdesk__count'; count.setAttribute('aria-live', 'polite');
    layer.appendChild(prev); layer.appendChild(next); layer.appendChild(count);
    wrap.appendChild(layer);
    function update() { count.textContent = (F.selectedIndex + 1) + ' / ' + F.slides.length; }
    /* REQ-065: a tap (not a drag) on the photo peeking beside the selected one moves to it (Ran 03.11) */
    function peek(e, pointer, cell, i) { if (typeof i === 'number' && i !== F.selectedIndex) F.select(i); }
    /* REQ-017: a design change with image sets rebuilds the slideshow; follow the new instance */
    document.addEventListener('pm:gallery-rebuilt', function (e) {
      var nf = e.detail && e.detail.el === slideshow && window.Flickity.data(slideshow);
      if (nf && nf !== F) { F = nf; F.on('change', update); F.on('staticClick', peek); update(); }
    });
    prev.addEventListener('click', function () { F.previous(true); });
    next.addEventListener('click', function () { F.next(true); });
    F.on('change', update);
    F.on('staticClick', peek);
    update();
    column(slideshow);
    /* Ran 20.10 removed a loose photo tap that caught scrolls on phones; REQ-059 brings it back with a strict tap rule in pampas-gallery-tap.js */
  }
  /* REQ-065 · desktop thumbnail column (CSS in pampas-gallery-desk.liquid): as many squares as fit the photo height, the last
     one showing "+K" for the rest; a click on it opens the full-screen view at that photo. */
  var WIDE = window.matchMedia('(min-width: 1024px)');
  function column(slideshow) {
    var root = slideshow.closest('.product__photos--below');
    var sc = root && root.querySelector('.product__thumbs--scroller');
    if (!root || !sc || sc.dataset.pmCol) return;
    sc.dataset.pmCol = '1';
    var bound = typeof WeakSet === 'function' ? new WeakSet() : null;
    /* the slideshow is replaced on a design switch (REQ-017): look it up each time */
    function slider() {
      var el = root.querySelector('.product__main-photos .flickity-enabled');
      var F = el && window.Flickity.data(el);
      if (F && bound && !bound.has(F)) { bound.add(F); F.on('change', function () { setTimeout(layout, 0); }); }
      return F;
    }
    /* the theme renumbers the thumb links (not their items) to slide positions on a rebuild */
    function pos(item) { return +item.querySelector('.product__thumb').getAttribute('data-index'); }
    function layout() {
      sc.querySelectorAll('.pm-col-hidden, .pm-col-more').forEach(function (i) { i.classList.remove('pm-col-hidden', 'pm-col-more', 'pm-col-on'); i.removeAttribute('data-more'); });
      if (!WIDE.matches) return;
      var F = slider();
      var cells = F ? F.cells.length : Infinity;
      /* other designs' thumbs carry the theme's .hide, which a polish rule overrides with display:block (adversarial 03.11) */
      var every = [].slice.call(sc.querySelectorAll('.product__thumb-item'));
      var all = every.filter(function (i) { return i.querySelector('.product__thumb') && !i.classList.contains('hide') && getComputedStyle(i).display !== 'none'; });
      /* one square per photo: the card-and-candle list repeats positions while its media are untagged (02.11) */
      var seen = {};
      var items = all.filter(function (i) { var k = pos(i); if (!(k < cells) || seen[k]) return false; return (seen[k] = true); });
      items.sort(function (a, b) { return pos(a) - pos(b); });
      every.forEach(function (i) { if (items.indexOf(i) < 0) i.classList.add('pm-col-hidden'); });
      var n = Math.max(1, Math.floor((sc.clientHeight + 6) / 90)); /* 80px squares, 10px gaps, 2px padding top and bottom */
      if (items.length <= n) return;
      var more = items[n - 1];
      more.classList.add('pm-col-more');
      more.setAttribute('data-more', '+' + (items.length - n + 1));
      items.slice(n).forEach(function (i) { i.classList.add('pm-col-hidden'); });
      if (F && F.selectedIndex >= pos(more)) more.classList.add('pm-col-on');
    }
    /* capture phase, so the theme's thumb handler does not also run; the magnifier is the path REQ-059 uses */
    sc.addEventListener('click', function (e) {
      var more = e.target.closest('.pm-col-more');
      var F = more && slider();
      if (!F) return;
      e.preventDefault(); e.stopPropagation();
      F.select(pos(more), false, true);
      var z = F.selectedElement && F.selectedElement.querySelector('.js-photoswipe__zoom, .pm-spdp-zoom');
      if (z) setTimeout(function () { z.click(); }, 30);
    }, true);
    document.addEventListener('pm:gallery-rebuilt', function () { setTimeout(layout, 50); });
    window.addEventListener('resize', layout);
    layout();
  }
  function scan() {
    document.querySelectorAll('[data-product-photos]').forEach(setup);
  }
  // Flickity is created by theme.js after DOMContentLoaded; retry briefly until it exists.
  var tries = 0;
  function boot() { scan(); if (++tries < 20 && !document.querySelector('[data-pm-gdesk]')) setTimeout(boot, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  MQ.addEventListener && MQ.addEventListener('change', scan);
})();
